import { useEffect, useRef } from "react";
import { useAppContext } from "../app/useAppContext";

export function useRefetchOnOverlayClose(refetch: () => void): void {
  const { overlayClosedCount } = useAppContext();
  const seenRef = useRef(overlayClosedCount);
  useEffect(() => {
    if (seenRef.current === overlayClosedCount) return;
    seenRef.current = overlayClosedCount;
    refetch();
  }, [overlayClosedCount, refetch]);
}
